import { properties as TYPES } from 'state/actionTypes';

export function setAccessList(id, users) {
    return {
        type: TYPES.SET_ACCESS_LIST,
        payload: { id, users },
    };
}

export function updateEntityPhoto(data) {
    return {
        type: TYPES.UPDATE_ENTITY_PHOTO,
        payload: data,
    };
}
